import { ORDER_STATUSES, type OrderStatus, type StoreInfo } from '@multicrm/shared';

/** Вкладка списка заказов: «все» или один статус. */
export type StatusTab = 'all' | OrderStatus;

export function statusesForTab(tab: StatusTab): OrderStatus[] {
  return tab === 'all' ? [] : [tab];
}

/**
 * Статусы, которые реально есть у выбранных магазинов. Источник сам говорит,
 * чем пользуется (`statuses`); если не говорит — берём ключи его подписей, а
 * если и их нет — показываем весь канонический набор.
 *
 * Подписи нельзя считать списком статусов: их задают выборочно, и частично
 * заполненный список спрятал бы вкладки всех остальных.
 */
export function availableStatuses(stores: StoreInfo[]): OrderStatus[] {
  const own = new Set<string>();
  for (const store of stores) {
    for (const key of store.statuses ?? Object.keys(store.statusLabels ?? {})) own.add(key);
  }
  if (own.size === 0) return [...ORDER_STATUSES];
  return ORDER_STATUSES.filter((status) => own.has(status));
}
